import React from 'react';

import Chip from '@material-ui/core/Chip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

class ProporcionalChart extends React.Component {
  render() {
    let { candidatos, onSelect, selected } = this.props;
    let intencoes = [];
    if (candidatos && candidatos.length > 0) {
      let atual = null;
      candidatos.forEach(i => {
        if (
          atual === null ||
          atual.tipo !== i.tipo ||
          (atual.candidato ? atual.candidato.id : null) !==
            (i.candidato ? i.candidato.id : null)
        ) {
          atual = {
            tipo: i.tipo,
            candidato: i.candidato,
            partido: i.partido,
            total: 0.0,
            masculino: 0.0,
            feminino: 0.0,
          };
          intencoes.push(atual);
        }
        if (i.divisoes.length > 0) {
          atual[i.divisoes[0].nome.toLowerCase()] = i.media;
        } else {
          atual.total = i.media;
        }
      });
      intencoes.sort(
        (c1, c2) =>
          (!c2.candidato && !c2.partido ? -100.0 : c2.total) -
          (!c1.candidato && !c1.partido ? -100.0 : c1.total)
      );
      return (
        <div style={{ overflowX: 'auto', maxHeight: '450px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Voto</TableCell>
                <TableCell style={{ padding: '2px 28px 2px 12px' }} numeric>
                  Total
                </TableCell>
                <TableCell style={{ padding: '2px 28px 2px 12px' }} numeric>
                  Masculino
                </TableCell>
                <TableCell style={{ padding: '2px 28px 2px 12px' }} numeric>
                  Feminio
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {intencoes.map((c, i) => (
                <TableRow
                  key={i}
                  style={{ cursor: c.candidato ? 'pointer' : 'default' }}
                  selected={
                    selected && c.candidato && selected.id === c.candidato.id
                  }
                  onClick={() => onSelect(c)}
                >
                  <TableCell style={{ padding: '2px 28px 2px 12px' }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>
                        {c.tipo === 'BRANCO' ? 'Brancos' : ''}
                        {c.tipo === 'NULO' ? 'Nulos' : ''}
                        {c.tipo === 'INDECISO' ? 'Indecisos' : ''}
                        {c.tipo === 'NAO_VOTARA' ? 'Não Votará' : ''}
                        {c.tipo === 'OUTRO' ? 'Outro' : ''}
                        {c.tipo === 'CANDIDATO'
                          ? `${c.candidato.nome} (${c.candidato.numero})`
                          : ''}
                        {c.tipo === 'LEGENDA'
                          ? `Voto em Legenda (${c.partido.numero})`
                          : ''}
                      </span>
                      {c.tipo === 'LEGENDA' ? (
                        <Chip
                          key={c.id}
                          label={c.partido.sigla}
                          style={{
                            backgroundColor: c.partido.cor,
                            fontWeight: 'bold',
                            color: 'white',
                          }}
                        />
                      ) : (
                        ''
                      )}
                      {c.tipo === 'CANDIDATO' ? (
                        <Chip
                          key={c.id}
                          label={c.candidato.partido.sigla}
                          style={{
                            backgroundColor: c.candidato.partido.cor,
                            fontWeight: 'bold',
                            color: 'white',
                          }}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </TableCell>
                  <TableCell style={{ padding: '2px 28px 2px 12px' }} numeric>
                    {c.total.formatPercent()}
                  </TableCell>
                  <TableCell style={{ padding: '2px 28px 2px 12px' }} numeric>
                    {c.masculino.formatPercent()}
                  </TableCell>
                  <TableCell style={{ padding: '2px 28px 2px 12px' }} numeric>
                    {c.feminino.formatPercent()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default ProporcionalChart;



// WEBPACK FOOTER //
// ./src/components/mapas/ProporcionalChart.js